/**
 * Convert the json String object to Javascript object
 *
 * @param {string} jsonString - object as json string
 * @returns {Object} - Objet
 */
export function fromJson(jsonString) {
    return jsonString ? JSON.parse(jsonString) : [];
}

